<script setup lang="ts">
import Icon from "@/core/components/icon/Icon.vue";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";
import AiMenu from "@/core/components/icons/AiMenu.vue";

defineProps<{
    label: string;
    route: string;
    icon: string;
}>();
</script>

<template>
  <TooltipProvider>
    <Tooltip :delay-duration="350">
      <TooltipTrigger>
        <router-link
          :to="{ name: route }"
          class="button"
          active-class="button-active"
        >
          <span class="sr-only">{{ label }}</span>
          <Icon v-if="icon != 'ai'" :name="`mdi-${icon}`" :size="24" />
          <AiMenu v-else class="h-7 relative left-0.5" />
        </router-link>
      </TooltipTrigger>
      <TooltipContent side="right" class="text-sm">
        <p>{{ label }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
